export const DateUtil = new (class {
  constructor() {
    this.localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  convertDate(date) {
    // scorechart 사용(날짜 => 타임스탬프)
    return new Date(date).getTime();
  }
  convertTimeScale(timeStamp) {
    // console.log('timeStamp',timeStamp);

    var convertTime = new Date(timeStamp * 1000);

    var optionsT = {
      // year: 'numeric',
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: this.localTimezone,
    };
    var localTime = convertTime
      .toLocaleString("en-US", optionsT)
      .replace(",", ""); // 쉼표(,) 제거
    localTime = localTime.replace(/\//g, "-"); // "/"를 "-"로 대체
    // console.log('localTime',localTime,this.localTimezone);

    return localTime;
  }
  convertTimeScaleWithLocal(originalTime, timeZone) {
    let zonedDate = new Date(
      new Date(originalTime * 1000).toLocaleString("en-US", { timeZone })
    );
    zonedDate.getTime() / 1000;
    const year = zonedDate.getFullYear();
    const month = (zonedDate.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 +1 필요, 두 자리로 패딩
    const day = zonedDate.getDate().toString().padStart(2, "0"); // 날짜, 두 자리로 패딩
    const hours = zonedDate.getHours().toString().padStart(2, "0"); // 시간, 두 자리로 패딩
    const minutes = zonedDate.getMinutes().toString().padStart(2, "0"); // 분, 두 자리로 패딩
    var formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
    // console.log('formattedDateTime',formattedDateTime);

    return formattedDateTime;
  }
  convertCurrentHour(timeStamp) {
    let targetTime = new Date(this.convertDate(timeStamp));
    var day = targetTime.getDate().toString().padStart(2, "0"); //일 2자리 (01, 02 ... 31)
    var hour = ("0" + targetTime.getHours()).slice(-2);
    return day + hour;
  }
})();
